import { render, staticRenderFns } from "./costDirectMaterials.vue?vue&type=template&id=6d722090&scoped=true"
import script from "./costDirectMaterials.vue?vue&type=script&lang=js"
export * from "./costDirectMaterials.vue?vue&type=script&lang=js"
import style0 from "./costDirectMaterials.vue?vue&type=style&index=0&id=6d722090&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d722090",
  null
  
)

export default component.exports